import React, { useEffect, useState } from "react";
import { Pagination, Stack } from "@mui/material";
import moment from "moment";
import { Loader } from "../loader";
import api from "../../../api";
import { Search, Users } from "lucide-react";
import "./WaqarStats.css";

export const YubitReferrals = () => {
  const [loader, setLoader] = useState(true);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [uid, setUid] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const getReferredUsers = async (pageNum = 1) => {
    try {
      setLoader(true);
      const body = {
        page_num: pageNum,
        page_size: 20,
      };
      if (uid.trim()) body.uid = uid.trim();
      if (fromDate) body.start_time = `${fromDate} 00:00:00`;
      if (toDate) body.end_time = `${toDate} 23:59:59`;

      const res = await api.getYubitReferredUsers(body);
      if (res?.success) {
        setList(res?.list || []);
        setTotal(res?.total_count || 0);
      } else {
        setList([]);
        setTotal(0);
      }
    } catch (e) {
      console.error(e);
      setList([]);
      setTotal(0);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getReferredUsers(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    setPage(1);
    getReferredUsers(1);
  };

  const handleReset = () => {
    setUid("");
    setFromDate("");
    setToDate("");
    setPage(1);
    getReferredUsers(1);
  };

  const handlePageChange = (_, value) => {
    setPage(value);
    getReferredUsers(value);
  };

  return (
    <div className="waqar-dashboard">
      <div className="waqar-stats-grid">
        <div className="waqar-stats-section">
          <h2 className="waqar-section-title jc-sb">
            <div>
              <Users size={20} /> Yubit Referred Users
            </div>
            <div className="dateRange d-flex ai-center">
              <div className="formGroup mb-2 me-2">
                <label>UID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filter by UID"
                  value={uid}
                  onChange={(e) => setUid(e.target.value)}
                />
              </div>
              <div className="formGroup mb-2 me-2">
                <label>From</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="formGroup mb-2 me-2">
                <label>To</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <button className="themeBtn mx-2" onClick={handleSearch}>
                <Search size={23} />
              </button>
              <button className="themeBtn" onClick={handleReset}>
                Reset
              </button>
            </div>
          </h2>

          <div className="table-responsive-container mt-3">
            <table className="modern-table">
              <thead>
                <tr>
                  <th>UID</th>
                  <th>REGISTER TIME</th>
                  <th>VIP LEVEL</th>
                  <th>TEAM SIZE (NEXT LEVEL)</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && !loader ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", padding: 24 }}>
                      No referred users found
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.uid}>
                      <td>{item.uid}</td>
                      <td>
                        {item.registerTime
                          ? moment(item.registerTime).format("MMM D, YYYY • h:mm A")
                          : "-"}
                      </td>
                      <td>{item.vipLevel ?? "-"}</td>
                      <td>{item.totalUser ?? "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {total > 20 && (
            <div className="pagination-container mt-3">
              <div className="pagination-info">
                Showing {Math.min((page - 1) * 20 + 1, total)} to{" "}
                {Math.min(page * 20, total)} of {total} entries
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(total / 20)}
                  page={page}
                  onChange={handlePageChange}
                  shape="rounded"
                  variant="outlined"
                  size="medium"
                />
              </Stack>
            </div>
          )}
        </div>
      </div>

      {loader && <Loader />}
    </div>
  );
};
